import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { FormBuilder, FormGroup, ValidatorFn, AbstractControl, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { SingleEnvironmentDetails } from 'src/app/models/single-environment-details.model';
import { ServerCount } from 'src/app/models/server-count.model';
import { ConfigureSingleEnvironment } from 'src/app/types/environment.type';
import { EnvironmentService } from 'src/app/cloud-subscription/services/environment.service';
import { VirtualMachineService } from '../services/virtual-machine.service';
import { LocalStorageService } from 'src/app/services/localstorage.service';
import { Subscription } from 'rxjs';
import { StorageKeys } from 'src/app/Util/storage-keys';
import { faCloud } from '@fortawesome/free-solid-svg-icons';
import { VirtualMachineCostRequest, VMCreationRequest } from 'src/app/interfaces/vm.interface';
import { CostcalculatorService } from '../../shopping-cart/services/costcalculator.service';
import { PopupComponent } from 'src/app/common-layout/popup/popup.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Helper from 'src/app/Util/helper';
import { Router, RouterState } from '@angular/router';
import { CloudNotificationService } from 'src/app/services/cloud-notification.service';
import { CloudNotificationStyle } from 'src/app/models/cloud-notification-style.model';
import StringHelper from 'src/app/Util/string-helper';
import { environment } from 'src/environments/environment';
import { SubscriptionCreatedEnviornment } from 'src/app/interfaces/environment.interface';
import { Regex } from 'src/app/Util/keys';


@Component({
  selector: 'app-add-servers',
  templateUrl: './add-servers.component.html',
  styleUrls: ['./add-servers.component.sass']
})

export class AddServersComponent implements OnInit {
  @Output() updateWizardStep = new EventEmitter();
  @Output() passServerDetails = new EventEmitter();
  @Input() serverDetail: ServerCount
  @Input() annualMachinesAllowed: boolean
  @Input() environmentInfo: SingleEnvironmentDetails
  serverForm: FormGroup;
  formSubmitted: boolean = false;
  environment:ConfigureSingleEnvironment
  icons:any
  formRef;
  totalPayGVms:number = 0
  totalReservedServers : number
  routeState:any
  isCreatingVM :boolean = false;
  constructor(
    private readonly router: Router,
    private fb: FormBuilder,
    private vmService:VirtualMachineService,
    private localStorage:LocalStorageService,
    private costCalculatorService: CostcalculatorService,
    private envirForm: NgbModal,
    private createToast:CloudNotificationService,
    private location: Location) { }

  ngOnInit(): void {
    this.initializeIcon()
    this.initForm();
    this.setEnvironmentForm()
    this.populateServersValues()
    this.getDataFromState()
  }

  private getDataFromState(){
    this.routeState = history.state
  }

  getAvailableReservedServers(){
    let ans = 0
    if (this.environment.servers.length >= this.environment.reservedCapacity){
        ans = 0
    }
    else {
        ans = Math.abs(this.environment.reservedCapacity - this.environment.servers.length)
    }
    return ans
  }

  redirectToEnvDetails(

  ) {
    const dynamicUrl = StringHelper.replacePlaceholders(
      environment.routes.environment_detail,
      { subscriptionId: this.getSubscriptionId(), environmentId: this.routeState.environment.id }
    );


    this.router.navigate([`subscription/${dynamicUrl}`], { state: { environment: this.routeState.environment } });
  }

  onMachineChange(vms:number,input:HTMLInputElement = null){
    if(input != null){
      input.value = input.value.replace(/[^0-9]/g, '')
    }
    if (vms > this.getAvailableReservedServers()){
      this.totalPayGVms = Math.abs(vms - this.getAvailableReservedServers())
      return;
    }
    this.changeReservedServers(vms)
    this.totalPayGVms = 0
  }
  initForm(): void {
    this.getEnvironmentDetails()
  }

  private initializeIcon(){
    this.icons = {};
    this.icons.faCloud = faCloud;
  }

  private populateServersValues(){
   this.serverForm.controls['machines'].setValue(this.vmService.totalVms || 1)
   this.onMachineChange(this.serverForm.controls['machines'].value);
  }

  private getEnvironmentDetails(){
    let routeState = history.state
    if(routeState){
      this.environment = routeState.environment
    }
    this.totalReservedServers = this.environment.reservedCapacity
  }

  private changeReservedServers(vms:number){
    this.totalReservedServers = this.environment.reservedCapacity - vms
  }

  private setEnvironmentForm(){
    this.serverForm = this.fb.group({
      environmentName: [{ value: this.environment.environmentName, disabled: true }],
      cloudVendor: [{ value: this.environment.cloudVendor, disabled: true }],
      region: [{ value: this.environment.region, disabled: true }],
      operatingSystem: [{ value: this.environment.operatingSystem, disabled: true }],
      serverProfile: [{ value: this.environment.serverPlan, disabled: true }],
      nCacheVersion: [{ value: this.environment.nCacheVersion, disabled: true }],
      machines: [1, [Validators.required, Validators.min(1),Validators.pattern(Regex.integerRegex)]],
    }, { validators: this.atLeastOneFieldValidator });
  }


  atLeastOneFieldValidator: ValidatorFn = (control: AbstractControl): { [key: string]: boolean } | null => {
    const annual = control.get('machines');
    if ((annual && annual.value > 0)) {
      return null;
    }
    return { atLeastOneRequired: true };
  }

  onNext() {
    this.formSubmitted = true;
    if (this.serverForm.invalid) {
      return;
    }
    let details: ServerCount = {
      monthlyMachines : this.serverForm.value.machines,
      annualMachines: this.serverForm.value.machines
    }
    this.confirmPurchase()
  }

  navigateToDashboard() {
    this.router.navigate([environment.routes.subscription]);
  }

  private persistVmsInService(){
    this.vmService.totalVms = this.serverForm.controls['machines'].value
  }

  private confirmPurchase() {

    this.formRef = this.envirForm.open(PopupComponent);
    Helper.configurePopup(this.formRef, {
      viewCrossBtn:false,
      title: "Confirm Add Servers",
      message: `Are you sure you want to add servers to Environment ${this.environment.environmentName}?`,
      viewRadioBtn: true,
      btnTitle: "Confirm",
      valueProcessor: (receivedConfirmation) => {
        this.createVm(this.formRef);
        this.isCreatingVM = true;
        this.formRef.close();
      }
    });
  }

  private navigateBackToEnvironmentDetails(){
    this.location.back()
  }


  private showToastForAddServerSuccess(style:CloudNotificationStyle,message:string){
    this.createToast.createToastNotification('subscription', Helper.resolveErrorMessage(message), style);
  }

  isPAYG(): boolean {
    return StringHelper.isPAYG(this.environment.billingTerm)
  }

  private getSubscriptionId(){
    return this.localStorage.getItemSessionStorage(StorageKeys.SubscriptionId)
  }

  private createVm(formRef){
    let vm :VMCreationRequest = {
      subscriptionId:this.localStorage.getItemSessionStorage(StorageKeys.SubscriptionId),
      environmentName:this.environment.environmentName,
      vmCount:this.serverForm.controls['machines'].value,
      enableHttps:true,
      isPublicIAttached:false
    }
    this.vmService.createVMs(vm).subscribe({
      next:(res)=>{
        this.showToastForAddServerSuccess(CloudNotificationStyle.success,`Creation of servers started.`)
        this.formRef.close();
        this.isCreatingVM = false;
        this.navigateBackToEnvironmentDetails()
      },
      error:(err)=>{
        this.showToastForAddServerSuccess(CloudNotificationStyle.danger,Helper.resolveErrorMessage(err))
        this.isCreatingVM = false;
        this.formRef.close();
      }
    })
  }

}
